export default {
    GET_ITEMS(state) {
        return state.secteurs
    },
    GET_ITEMS_WITH_INTERVENTIONS(state) {
        return state.secteursWithInterventions
    }
}
